import { Stack, styled, Typography } from '@mui/material';
import { ReactNode } from 'react';

export interface EntityViewSectionTitleProps {
    /**
     * Section title text
     */
    title: string;
    /**
     * Icon displayed before the title
     */
    icon?: ReactNode;

    className?: string;
}

export default function EntityViewSectionTitle({ title, icon, className }: EntityViewSectionTitleProps) {
    return (
        <Root className={ className }>
            { icon }
            <Typography
                variant="subtitle1"
                fontWeight="bold"
            >
                { title }
            </Typography>
        </Root>
    );
}

const Root = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1)
}));
